import React from 'react';
export const CHECKOUT_URL = 'https://system.impultienda.ar/checkout/';
type CTAButtonProps = {
  label: string;
  sub?: string;
  icon?: string;
  id?: string;
};
export function CTAButton({
  label,
  sub,
  icon = '🔧',
  id
}: CTAButtonProps) {
  return <div className="w-full" id={id} data-id="element-27" data-mp="2kzzfenzpr6rq">
      <a href={CHECKOUT_URL} className="group flex w-full items-center justify-center gap-2 rounded-xl bg-gold-500 px-4 py-4 text-center font-display text-[19px] font-extrabold uppercase leading-[1.1] tracking-wide text-navy-950 shadow-[0_8px_0_0_#B8810A] transition-[transform,background-color,box-shadow] duration-150 ease-out hover:bg-gold-400 active:translate-y-[4px] active:shadow-[0_4px_0_0_#B8810A] sm:text-[24px] sm:py-5" data-id="element-28" data-mp="2fzuywxyt2c1i">
        <span aria-hidden="true" className="text-[20px] sm:text-[24px]" data-id="element-29" data-mp="2yquu4gww8i38">
          {icon}
        </span>
        <span className="max-w-[16ch] sm:max-w-none" data-id="element-30" data-mp="3cq42iueuy7wn">{label}</span>
      </a>
      {sub ? <p className="mt-3 text-center text-[11px] font-semibold uppercase tracking-[0.08em] text-white/70 sm:text-xs" data-id="element-31" data-mp="38q3m54877mmy">
          {sub}
        </p> : null}
    </div>;
}